import React, { Fragment, useEffect, useState } from "react";

import moment from "moment";

import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

import ConfirmButton from "../../../../common/components/ConfirmButton";
import RemoveOptions from "./Actions/RemoveOptions";
import { compose } from "redux";
import loanConnector from "../../../../services/loan/connector";
import { restRepaymentConnector } from "../../../../services/loan/restRepayments/connector";

const ActionsRenderer = ({
  item,
  updateLoanStatus,
  getFullRepayment,
  removeFees,
  setLoanToDisputed,
  setLoanToUndisputed,
  restRepayLoan,
  setInvoiceMethod,
  callback,
  setPpiStatus,
}) => {
  const from = moment(item.IssueDate);
  const now = moment(new Date());
  const diff = now.diff(from, "days");
  const regretEndDate = moment(now).add(30, "days");

  useEffect(() => {
    getFullRepayment(item.Id, new Date());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [removeOption, changeRemoveOption] = useState("");
  const [text, setText] = useState("");

  function _updateLoanStatus() {
    const asOfDate = new Date();
    updateLoanStatus(item.Id, asOfDate);
  }

  function _set_invoice_method(method) {
    setInvoiceMethod(item.Guid, method);
  }

  let menuItems = [
    <MenuItem value="all" key={1}>
      Remove all
    </MenuItem>,
    <MenuItem value="byType" key={2}>
      Remove all by type
    </MenuItem>,
    <MenuItem value="byTypeOnDate" key={3}>
      Remove all by type and on date
    </MenuItem>,
    <MenuItem value="allOnDate" key={4}>
      Remove all on date
    </MenuItem>,
    <MenuItem value="allSinceDate" key={5}>
      Remove all since date
    </MenuItem>,
    <MenuItem value="byTypeSinceDate" key={6}>
      Remove all by type and since date
    </MenuItem>,
  ];

  return (
    <React.Fragment>
      <h4>Actions</h4>
      <div className="vertical-padding">
        <ConfirmButton label={"Regret"} action={_updateLoanStatus}>
          {diff > 14 && (
            <p className="error">
              Regret no longer possible 14 days have passed sisnce issue date
            </p>
          )}
          <p>
            {diff} days since the loan was taken are you sure you want to start
            the regret perod?
          </p>
          <p>
            It will last for 30 days till {regretEndDate.format("YYYY-MM-DD")}
          </p>
        </ConfirmButton>
      </div>
      <div className="vertical-padding">
        <p>
          <strong>Remove fees</strong>
        </p>
        <TextField
          size="small"
          variant="outlined"
          select
          label="Remove option"
          value={removeOption}
          onChange={(e) => {
            changeRemoveOption(e.target.value);
          }}
        >
          {menuItems}
        </TextField>
        <br />
        <RemoveOptions
          removeOption={removeOption}
          item={item}
          removeFees={removeFees}
        />
        <br />
        {item.CapitalDebt &&
        item.CapitalDebt.Amount <= 10 &&
        item.CapitalDebt.Amount > 0 ? (
          <ConfirmButton
            label="Rest repay loan"
            refreshKey={item.Id}
            action={() => {
              restRepayLoan(item.Id, callback);
            }}
          />
        ) : undefined}
      </div>
      {item.DisputedSince ? (
        <div className="vertical-padding">
          <ConfirmButton
            label={"Set undisputed"}
            action={() => {
              setLoanToUndisputed(item.Id, text);
            }}
          >
            <p>
              Setting loan to undisputed (you can provide a reason below but not
              mandatory)
            </p>
            <TextField
              variant="outlined"
              label="Undisputed reason"
              fullWidth
              multiline
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </ConfirmButton>
        </div>
      ) : (
        <div className="vertical-padding">
          <ConfirmButton
            label={"Set disputed"}
            validation={text}
            action={() => {
              setLoanToDisputed(item.Id, text);
            }}
          >
            <p>To set Loan to disputed please provide a reason</p>
            <TextField
              variant="outlined"
              label="Disputed reason"
              fullWidth
              multiline
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </ConfirmButton>
        </div>
      )}
      {item.ImportSource == "Lunar" ? (
        <div>
          <h3>Invoice method</h3>

          <p>
            The change will take a day until its reflected in the interface
            check BE admin to know if the event is registered
          </p>
          <p>
            For paper, make sure the borrower has a vaid adres in the system,
            otherwise it will fallback to email.
          </p>
          <ConfirmButton
            label={"Paper"}
            action={() => _set_invoice_method("Paper")}
          />
          <ConfirmButton
            label={"Email"}
            action={() => _set_invoice_method("Email")}
          />
          <ConfirmButton
            label={"DirectDebit"}
            action={() => _set_invoice_method("DirectDebit")}
          />
          <br />
          <br />

          <h3>PPI fee</h3>
          <ConfirmButton
            label={"Remove ppi-subscription (active from tomorrow)"}
            action={() => setPpiStatus(item.Guid, false)}
          />
        </div>
      ) : (
        <Fragment />
      )}
    </React.Fragment>
  );
};
export default compose(loanConnector, restRepaymentConnector)(ActionsRenderer);
